import { Icon } from "@iconify/react";
import arrowImg from "../media/arrowImg.png"
import gal from "../media/schoolGal.avif"
import boy from "../media/pexels-katerina-holmes-5905515-Photoroom.avif"
import yellowline from "../media/orangehiglighter.png"
import "../css/landing.css"
import SquareCarousel from "../components/testimonial";
import ball from "../media/ball.png"
import baby from "../media/baby.avif"
import sun from "../media/sun.png"
import "aos/dist/aos.css";
import logo from "../media/blueLogo.png"
import useGenStore from "../store/genstore";
import FonSideBar from "../components/fonnSideBar";
import Loader from "./loader";
import blob from "../media/blob.svg"
import video1 from "../media/vida1.mp4"
import robotKids from "../media/robotKids.avif"
import video2 from "../media/vida2.mp4"
import bottle from "../media/bottle.png"
import animeGal from "../media/animeGal.png"
import stationaery from "../media/stationary.png"
import accesory from "../media/bag.png"
import rocket from "../media/rocket.avif"
import cloud from "../media/cloud.png"
import bag2 from "../media/bag2.png"
import pencil from "../media/pencil.png"
import books from "../media/books.png"
import math from "../media/math.png"
import gallery1 from "../media/gallery1.avif"
import gallery2 from "../media/gallery2.avif"
import { Helmet } from "react-helmet";
import gallery3 from "../media/gallery3.avif"
import gallery4 from "../media/gallery4.avif"
import gallery5 from "../media/gallery5.avif"
import gallery6 from "../media/gallery6.avif"
import Cart from "../components/cart";
import world from "../media/world.avif"
import Navbar from "../components/navbar";
import { useRef,useState,useEffect } from "react";
import Aos from "aos";
import { useNavigate } from "react-router-dom";

import {
  AnimatePresence,
  animate,
  motion,
  useMotionValue,
  usePresenceData,
  useTransform,
  wrap,
} from "motion/react";
function Landing() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
  const handleLoad = () => {
    setLoading(false);
  };
  const contactUs = () => {
  window.location.href = "tel:+254719140419";
};

  if (document.readyState === "complete") {
    handleLoad();
  } else {
    window.addEventListener("load", handleLoad);
    return () => window.removeEventListener("load", handleLoad);
  }
}, []);

const [activeVideo, setActiveVideo] = useState(1);
const video1Ref = useRef(null);
const video2Ref = useRef(null);
     const navigate = useNavigate();
     const cartView = useGenStore((s)=>s.cartView)


const handleVideo1End = () => {
  setActiveVideo(2);
  video2Ref.current.play();
};

const contactUs = () => {
  window.location.href = "tel:+254719140419";
};

const handleVideo2End = () => {
  setActiveVideo(1);
  video1Ref.current.play();
};

      
    useEffect(()=>{
         Aos.init({duration:1000})

    },[])
  
  

  return (
    < div className="LandingWrapCont">
    <Helmet>
  <title>Premium Customized School Labels</title>
  <meta name="description" content="No more lost school items. Durable iron-on labels for school uniforms & stick-on labels for stationery & accessories. Trusted by 49.1k+ parents. Start labeling today!" />
</Helmet>
    {loading ? (<Loader/>):(  <>
    <FonSideBar />
      <div className="floatNav">
        <Navbar />
      </div>
      <div className={`floatCart ${cartView ? "floatCartActive" : ""}`}>
        <Cart />
      </div>
      <section className="hero">
          <div className="heroCont heroDesktop">
            <div className="heroContTop">
   <h1>
  Premium Customized School{" "}
<span className="toHighLightWord">
  <span className="text">Labels</span>
  <img src={yellowline} alt="highlight" className="underlineImg" />
</span>
</h1>
              <p>
               No More lost School Items.
               </p> <p> Durable Iron-On Labels for School Uniforms & Stick-On Labels for Stationery & Accessories.</p>
              <motion.div 
               whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.8 }}
                onClick={()=> navigate("/branding")}
              className="heroBtnDesk">
                <span>Start Labeling</span>
                <div className="hbtnDeskIcon">
                  <Icon
                    icon="solar:alt-arrow-right-linear"
                    className="faIcon"
                  />
                </div>
              </motion.div>
            </div>
            <div className="heroContBtm">
              <div className="hcbLeft">
                 <img className="floatingDrawings f1" src={cloud} alt="" />
                <img className="floatingDrawings f2" src={world} alt="" />
                <img className="floatingDrawings f4" src={math} alt="" />
                    
       <div className="circle-container galContainer">
  <div className="circle-mask">
    <img src={gal} alt="person" className="person-img" />
  </div>

  <img src={gal} alt="person" className="person-top" />
</div>
              </div>
              <div className="hcbMid">
                <div className="hcbMidCardLeft">
                  <div className="hcbMidCardLeftT">
                    <div className="hcbMLTIcon">
                      <Icon icon="solar:user-rounded-bold" className="faIcon" />
                    </div>
                    <div className="hcbMLTCont">
                      <h2>49.1k+</h2>
                      <p>Labels, trusted by Parents & Guardians for labels that last .</p>
                    </div>
                  </div>
                  <div className="hcbMidCardLeftB">
                       <img src={arrowImg} alt="" />
                  </div>
                </div>
                <div className="hcbMidCardRight">
                    <div className="hcbMidCardRightT">
                       <img src={arrowImg} alt="" />
                    </div>
                     <div className="hcbMidCardRightB">
                    <div className="hcbMRTIcon">
                      <Icon icon="solar:bolt-bold" className="faIcon" />
                    </div>
                    <div className="hcbMRTCont">
                      <h2>18.5k+</h2>
                      <p>Designs completed .</p>
                    </div>
                  </div>
                
                </div>
              </div>
              <div className="hcbRight">
                <img className="floatingDrawings f1" src={rocket} alt="" />
                <img className="floatingDrawings f2" src={sun} alt="" />
                <img className="floatingDrawings f3" src={ball} alt="" />
                  <div className="circle-container boyContainer">
  <div className="circle-mask boyCircle">
    <img src={boy} alt="person" className="person-img" />
  </div>
  <img src={boy} alt="person" className="person-top" />
</div>
              </div>
            </div>
          </div>
          <div className="fonHero">
       
            <div className="fonHeroTop">
                   <img className="fonFloats ff1" src={rocket} alt="" />
            <img className="fonFloats ff2" src={world} alt="" />
            <img className="fonFloats ff3" src={pencil} alt="" />
            <img className="fonFloats ff4" src={math} alt="" />
            <div className="fonHeroCont">
              
            </div>

<h1>
  Premium Customized School {" "}
<span className="toHighLightWord">
  <span className="text">Labels</span>
  <img src={yellowline} alt="highlight" className="underlineImg" />
</span>
</h1>                  <div className="kafonLine"></div>
                  <p> No More lost School Items. Durable Iron-On Labels for School Uniforms & Stick-On Labels for Stationery & Accessories.</p>
                    <motion.div 
               whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.8 }}
                onClick={()=> navigate("/branding")}
              className="heroBtnDesk">
                <span>Start Labeling</span>
                <div className="hbtnDeskIcon">
                  <Icon
                    icon="solar:alt-arrow-right-linear"
                    className="faIcon"
                  />
                </div>
              </motion.div>
            </div>
            <div className="fonHeroBtm">
              
                  <div className="fonHeroBtmTop">


  <div className="circle-container galContainer">
  <div className="circle-mask">
    <img src={gal} alt="person" className="person-img" />
  </div>

  <img src={gal} alt="person" className="person-top" />
</div>


                  </div>
                  <div className="fonHeroBtmBtm">

                    
                    <div className="fonBtmCards">
                      <div className="fbsCard">
                        <div className="kaSaco1"></div>
                        <div className="fbsCont">
                          <div className="fbsLeft fbsLeft1">
                      <Icon icon="solar:user-rounded-bold" className="faIcon" />
                          </div>
                          <div className="fbsRight">
                            <span>49.1k+</span>
                            <p>Labels, trusted by Parents & Guardians for labels that last.</p>
                          </div>
                        </div>
                      </div>
                      <div className="fbsCard">
                        <div className="kaSaco2"></div>

                        <div className="fbsCont">
                          <div className="fbsLeft fbsLeft2">
                      <Icon icon="solar:bolt-bold" className="faIcon" />
                          </div>
                          <div className="fbsRight">
                            <span>18.5k+</span>
                            <p>Designs Completed </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
            </div>
          </div>
      </section>
      <div className="miniServices">
        <div className="msPlacer">
          <div className="msMiniPlacer">
<div className="msTitle">
            <h2>We Label</h2>
            <p>Custom uniforms, student accessories, and stationery marked for identification.</p>
          </div>
          <div className="msCards">
            <div className="msCard">
                            <div className="msCardCircle"></div>

              <div className="msCardImg">
                <img src={animeGal} alt="" />
              </div>
              <div className="msCont">
                <span>School Uniforms</span>
                <p>Durable, personalized, iron-on, neat.</p>
              </div>
            </div>
            <div className="msCard">
                            <div className="msCardCircle"></div>

              <div className="msCardImg">
                <img src={stationaery} alt="" />
              </div>
              <div className="msCont">
                <span>Stationery</span>
                <p>Easy-to-identify & fun & practical.</p>
              </div>
            </div>
            <div className="msCard">
              <div className="msCardCircle"></div>
              <div className="msCardImg">
                <img src={bottle} alt="" />
              </div>
              <div className="msCont">
                <span>Accessories</span>
                <p>Stick-on, colorful, organized, reliable.</p>
              </div>
            </div>
          </div>
          </div>
          
        </div>

      </div>
      <section className="Process">
        <div className="processLeft">
          <img className="blobProcess" src={blob} alt="" />
          <div className="processCont">
            <div className="pcActCont">
              <h1>

                <span className="toHighLightWord">
  <span className="text">Stick On</span>
  <img src={yellowline} alt="highlight" className="underlineImg" />
</span>
  {" "} 
              
                
                 </h1>
              
              <h2> demonstration video</h2>
              <p>Watch our Stick-On labels in action easy to apply, durable, and perfect for school items.</p>

              <div className="processBtn"  
               onClick={()=>navigate("/branding")}
                >
                <div className="prBtnIcon">
                    <Icon icon="solar:arrow-right-outline" className="faIcon"/>
                </div>
                <p>Label Now</p>
              </div>
            </div>
          </div>

        </div>
        <div className="processRight">
  <video
    ref={video1Ref}
    autoPlay
    muted
    className={`bgVideo`}
    controls={false}
    src={video2}
  />

          <div className="proBoxed">
            <div className="upArrowBoxed">
              <Icon icon="solar:arrow-right-up-linear" className="faIcon"/>
            </div>
            <h2>Do {" "}
            
                <span className="toHighLightWord2">
  <span className="text">this!</span>
  <img src={yellowline} alt="highlight" className="underlineImg2" />
</span></h2>
            <img src={baby} alt="" />


          </div>

        </div>


      </section>
      <section className="Process2">
        <div className="processLeft">
          <img className="blobProcess" src={blob} alt="" />
          <div className="processCont">
            <div className="pcActCont">
              <h1> 

                <span className="toHighLightWord">
  <span className="text">Iron On</span>
  <img src={yellowline} alt="highlight" className="underlineImg" />
</span>
                
                
                 </h1>
              
              <h2>demonstration video</h2>
              <p>See Iron-On labels in action—strong, long-lasting, and ideal for school uniforms and fabric items.</p>

             
            </div>
          </div>

        </div>
        <div className="processRight">
  <video
    ref={video1Ref}
    autoPlay
    muted
    className={`bgVideo`}
    src={video1}
  />

 



        </div>


      </section>
      <section className="StickOnProcess">
        <div className="stickOnPlacer">
          <div className="stickOnIntro">
            <h2>How to use {" "}
            
                <span className="toHighLightWord">
  <span className="text"> stick-on </span>
  <img src={yellowline} alt="highlight" className="underlineImg" />
</span>
                
             {""} labels</h2>
          </div>
      <div className="stickOnCont">
  <div className="stickOnCard">
    <div className="stlickOnCardIntro">
      <h3> <span>1.</span> Separate the sticker</h3>
    </div>
    <div className="stickOnCardCont">
      <p>Carefully peel the sticker from its backing sheet without touching the adhesive.</p>
    </div>
  </div>
  <div className="stickOnCard">
    <div className="stlickOnCardIntro">
      <h3> <span>2.</span> Stick and press</h3>
    </div>
    <div className="stickOnCardCont">
      <p>Place the sticker on the desired surface and press firmly to secure it in place.</p>
    </div>
  </div>
  <div className="stickOnCard">
    <div className="stlickOnCardIntro">
      <h3> <span>3.</span> Peel off outer layer</h3>
    </div>
    <div className="stickOnCardCont">
      <p>Gently remove the protective top layer, leaving the sticker perfectly attached to the surface.</p>
    </div>
  </div>
</div>
          <div className="tryStickOn">
            <p> <span 
onClick={() => navigate("/branding")}      
      >Try out </span>our stick-on lables.</p>
          </div>
        </div>
      </section>
      <section className="ironOnLabels">
        <div className="ironOnPlacer">
          <div className="ironOnIntro">
            <h2>The {" "}
            
                <span className="toHighLightWord">
  <span className="text"> iron-on  </span> 
  <img src={yellowline} alt="highlight" className="underlineImg" />
</span>
                      
               {" "} procedure</h2>
          </div>
          <div className="theironOnCont">
            <div className="theironOnContCard">
              <div className="theironOnContCardWrap">
              <div className="ticcIcon">
                   <p>Step 1</p>
              </div>
              <div className="ticcminiTtile">
                  <h3>Iron the label onto the garment for 15 seconds.</h3>
              </div>
              </div>
            
            </div>
            <div className="theironOnContCard">
              <div className="ironOnCircle"></div>
              <div className="theironOnContCardWrap">
 <div className="ticcIcon">
                   <p>Step 2</p>
              </div>
              <div className="ticcminiTtile ticcminiTtile2">
                  <h3>Allow it to cool for sometime.</h3>
              </div>
             
              </div>
             
            </div>
            <div className="theironOnContCard">
              <div className="theironOnContCardWrap">
 <div className="ticcIcon">
                   <p>Step 3</p>
              </div>
              <div className="ticcminiTtile">
                  <h3>Peel the outer layer of the label.</h3>
              </div>
            
              </div>
             
            </div>
          </div>
        </div>
      </section>
      <section className="gallery">
        <div className="galleryPlacer">
          <div className="galleryIntro">
               <h2>Our Work</h2>
               <p>Crafted to Stand Out</p>
          </div>
          <div className="galleryCont">
            <div className="gcContCard">
            <img src={gallery1} alt="" />
            <div className="gcContCardOverlay">
              <button onClick={()=>(navigate("/branding"))}>Label Now</button>
            </div>

            </div>
            <div className="gcContCard">
            <img src={gallery2} alt="" />
            <div className="gcContCardOverlay">
              <button onClick={()=>(navigate("/branding"))}>Label Now</button>
            </div>

            </div>
            <div className="gcContCard">
            <img src={gallery3} alt="" />
            <div className="gcContCardOverlay">
              <button onClick={()=>(navigate("/branding"))}>Label Now</button>
            </div>

            </div>
            <div className="gcContCard">
            <img src={gallery4} alt="" />
            <div className="gcContCardOverlay">
              <button onClick={()=>(navigate("/branding"))}>Label Now</button>
            </div>

            </div>
            <div className="gcContCard">
            <img src={gallery5} alt="" />
            <div className="gcContCardOverlay">
              <button onClick={()=>(navigate("/branding"))}>Label Now</button>
            </div>

            </div>
            <div className="gcContCard">
            <img src={gallery6} alt="" />
            <div className="gcContCardOverlay">
              <button onClick={()=>(navigate("/branding"))}>Label Now</button>
            </div>

            </div>
          
    
          </div>

        </div>

      </section>
      {/* <div className="genFooter"> */}
 <section className="semiBurner">
        <div className="semiBurnerTop">
<img data-aos="fade-right" className="sbImg sbImg1"  src={pencil} alt="" />
        <img data-aos="fade-in"  className="sbImg sbImg2"  src={books} alt="" />
        <img data-aos="fade-in" className="sbImg sbImg3"  src={bag2} alt="" />
        <img data-aos="fade-in" className="sbImg sbImg4"  src={ball} alt="" />
        <img data-aos="fade-down" className="sbImg sbImg5"  src={cloud} alt="" />
        <div  className="semiBurnerPlacer">
          <h2>Premium <span className="orangeBack">labels</span> <br />
          for <span className="pinkWord">cool</span>  kids' school <span className="blueColor">items</span>.</h2>
           <motion.div 
               whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.8 }}
              className="heroBtnDesk">
                <span onClick={()=>navigate("/branding")}>Make Your Order</span>
                <div className="hbtnDeskIcon">
                  <Icon
                    icon="solar:alt-arrow-right-linear"
                    className="faIcon"
                  />
                </div>
           </motion.div>
        </div>
        </div>
        
        <div className="semiBurnerAllowance">
          
        </div>
            
      </section>
      <footer>
        <div data-aos="slide-up" className="footerTopAllowance">
   <div  className="floatBurner">
    <div className="fBurnerPlacer">
      <div className="fbLeft"> 
        <img src={robotKids} alt="" />

      </div>
      <div className="fbRight">
        <h2>Testimonials</h2>
        <SquareCarousel />
      </div>
    </div>
              
             </div>
        </div>
        <div className="footerPlacer">
          <div className="footerWrapLinks">
<div className="footerLeft">
            <img src={logo} alt="" />
          </div>
          <div className="footerRight">
            <div className="frLeft">

                  <h3>Navigation</h3>
                  <p onClick={()=>{navigate("/")}}>Home</p>
                  <p onClick={()=>{contactUs()}}>Contact Us</p>
                  <p 
                   onClick={()=>navigate("/branding")}
                   >Make Order</p>
                   <p>admin@schoollabelskenya.com</p>
            </div>
            <div className="frRight">
  <h3>Contact & Socials</h3>
   <p onClick={() => window.open("https://www.tiktok.com/@schoollabelske", "_blank")}>
    Tiktok
  </p>

  <p onClick={() => window.open("https://www.instagram.com/schoollabelskenya/", "_blank")}>
    Instagram
  </p>

  <p onClick={() => window.open("https://www.facebook.com/people/School-Labels-Kenya/pfbid02ngjWM5haXy3RyBBN1yijxczcE7cmJDc6XT1P2ZbD3tje2zDvJ4G4JJ7mKQ4ZAwUrl/", "_blank")}>
    Facebook
  </p>

  <p onClick={() => contactUs()}>
    Tel No. +254719140419
  </p>
</div>
          </div>
          </div>
          <div className="footerCopy">
            <span>Copyright &copy; 2026 School Labels Kenya. All RIghts Reserved.</span>
          </div>
          
        </div>

      </footer>
     

      
        </>)}
    
    </div>
  

  );
}

export default Landing;
